/**
 * Algolia hits sometimes use `objectID` as string or number; normalise for URLs and React keys.
 */
export function normalisedAlgoliaJobObjectId(objectID: unknown): string {
  if (objectID == null) return '';
  return String(objectID).trim();
}

export function algoliaJobHitHasStableObjectId(hit: { objectID?: unknown }): boolean {
  return normalisedAlgoliaJobObjectId(hit.objectID) !== '';
}
